import React, { useState } from "react";
import {
  Box,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Avatar,
} from "@mui/material";
import "../../Styles/Layouts/common_topbar.css";
import { Link } from "react-router-dom";

const Topbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="topbar">
      <Box>
        <Typography variant="h3">SUPER ADMIN</Typography>
        <div>
          <Tooltip title="Account">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar />
            </IconButton>
          </Tooltip>
          <Menu
            className="menu-container"
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem>
              {" "}
              <Link className="link" to="/superadmin/Superadmin_ResetPassword">
                Reset Password{" "}
              </Link>
            </MenuItem>
          </Menu>
        </div>
      </Box>
    </div>
  );
};

export default Topbar;
